import AdminThemeColors from '../../../includes/assets/js/modules/AdminThemeColors';
import DpitAdminToolbar from './modules/DpitAdminToolbar';

window.$ = jQuery;
if (window.dp_admin_toolbar_config.dpDebugEn) console.log('[dpit] INIT Admin config:', window.dp_admin_toolbar_config);
new DpitAdminToolbar(window.dp_admin_toolbar_config);

jQuery(document).ready(() => {
	if (window.dp_admin_toolbar_config.adminColors) {
		new AdminThemeColors(window.dp_admin_toolbar_config);
	}
});
